// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-list';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.89 3.953a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0zm3.454 4.026a4.54 4.54 0 0 0-.532-.042 4.781 4.781 0 0 0-4.78 4.782m8.499-4.25h6.375s1.063 0 1.063 1.062v6.375s0 1.063-1.063 1.063H9.531s-1.062 0-1.062-1.063V9.531s0-1.062 1.062-1.062zm1.063 2.125h4.25m-4.25 2.125h4.25m-4.25 2.125h1.594'
  />
);

export const viewBox = '0 0 18 18';
